import { httpClient } from '../http';
import {
	GetCompletedCyclesQueryParams,
	MostActiveUserResponse,
	MostActiveUsersQueryParams,
	MostCleanedLocationResponse,
	MostCleanedLocationsQueryParams,
	ExportMostActiveUsersQueryParams,
	MostActiveDevicesQueryParams,
	MostActiveDeviceResponse,
	GetAllCyclesMultilineQueryParams,
	AllCyclesResponse,
} from './types';

export const getMostActiveUsers = async (
	siteId: string,
	queryParams: MostActiveUsersQueryParams
): Promise<MostActiveUserResponse[]> => {
	const { data } = await httpClient.get<MostActiveUserResponse[]>(`/logs/users/${siteId}`, {
		params: queryParams,
	});

	return data;
};

export const getMostActiveUsersForAllSites = async (
	queryParams: MostActiveUsersQueryParams
): Promise<MostActiveUserResponse[]> => {
	const { data } = await httpClient.get<MostActiveUserResponse[]>('/logs/users', {
		params: queryParams,
	});

	return data;
};

export const getMostActiveDevices = async (
	siteId: string,
	queryParams: MostActiveDevicesQueryParams
): Promise<MostActiveDeviceResponse[]> => {
	const { data } = await httpClient.get<MostActiveDeviceResponse[]>(`/logs/devices/${siteId}`, {
		params: queryParams,
	});

	return data;
};

export const getMostActiveDevicesForAllSites = async (
	queryParams: MostActiveDevicesQueryParams
): Promise<MostActiveDeviceResponse[]> => {
	const { data } = await httpClient.get<MostActiveDeviceResponse[]>('/logs/devices', {
		params: queryParams,
	});

	return data;
};

export const getMostCleanedLocations = async (
	siteId: string,
	queryParams: MostCleanedLocationsQueryParams
): Promise<MostCleanedLocationResponse[]> => {
	const { data } = await httpClient.get<MostCleanedLocationResponse[]>(
		`/logs/locations/${siteId}`,
		{
			params: queryParams,
		}
	);

	return data;
};

export const getMostCleanedLocationsForAllSites = async (
	queryParams: MostCleanedLocationsQueryParams
): Promise<MostCleanedLocationResponse[]> => {
	const { data } = await httpClient.get<MostCleanedLocationResponse[]>('/logs/locations', {
		params: queryParams,
	});

	return data;
};

export const exportMostActiveUsers = async (
	siteId: string,
	queryParams: ExportMostActiveUsersQueryParams
): Promise<string> => {
	const { data } = await httpClient.get<string>(`/logs/users/export/${siteId}`, {
		responseType: 'blob',
		params: queryParams,
	});

	return data;
};

export const exportMostActiveUsersForAllSites = async (
	queryParams: ExportMostActiveUsersQueryParams
): Promise<string> => {
	const { data } = await httpClient.get<string>('/logs/users/export', {
		responseType: 'blob',
		params: queryParams,
	});

	return data;
};

export const exportMostCleanedLocations = async (
	siteId: string,
	queryParams: MostCleanedLocationsQueryParams
): Promise<string> => {
	const { data } = await httpClient.get<string>(`/logs/locations/export/${siteId}`, {
		responseType: 'blob',
		params: queryParams,
	});

	return data;
};

export const exportMostCleanedLocationsForAllSites = async (
	queryParams: MostCleanedLocationsQueryParams
): Promise<string> => {
	const { data } = await httpClient.get<string>('/logs/locations/export', {
		responseType: 'blob',
		params: queryParams,
	});

	return data;
};

export const getCompletedCycleLogs = async (
	siteId: string,
	queryParams: GetCompletedCyclesQueryParams
): Promise<AllCyclesResponse> => {
	const { data } = await httpClient.get<AllCyclesResponse>(`/logs/${siteId}`, {
		params: queryParams,
	});

	return data;
};

export const getAllCycleLogs = async (
	queryParams: GetAllCyclesMultilineQueryParams
): Promise<AllCyclesResponse> => {
	const { data } = await httpClient.get<AllCyclesResponse>(`/logs/aggregated`, {
		params: queryParams,
	});

	return data;
};

export const getAllCycleLogsBelowCurrentLevel = async (
	queryParams: GetAllCyclesMultilineQueryParams
): Promise<AllCyclesResponse> => {
	const { data } = await httpClient.get<AllCyclesResponse>(`/logs`, {
		params: queryParams,
	});

	return data;
};
